export default {
  ApplicationInfo: 'Xin thông tin',
  Game: 'Trò Chơi ',
  Account: 'Tài khoản',
  Server: 'Server',
  CharacterName: 'Tên nhân vật',
  PlatformOrderNumber: 'Mã giao dịch kênh',
  Amount: 'Số tiền',
  InvoiceMethod: 'Phương thức xuất hóa đơn',
  InvoiceByTotalOrderAmount: 'Xuất hóa đơn theo tổng giá trị giao dịch',
  InvoiceByOrderAmountSeparately:
    'Xuất hóa đơn riêng theo từng giá trị giao dịch',
  PhoneNumber: 'Số điện thoại liên hệ',
  Name: 'Tên',
  Address: 'Địa chỉ',
  InvoiceTitle: 'Tiêu đề hóa đơn',
  PersonalTitleOnlyNoCompany:
    'Chỉ được dùng tên cá nhân, không được dùng tên công ty',
  ReceivingEmail: 'Email nhận',
  Remarks: 'Ghi chú',
  InputContent: 'Nhập nội dung',
  ApplicationSubmittedSuccessfully: 'Đã gửi yêu cầu thành công',
  InvoiceApplicationSubmittedSuccessfully:
    'Yêu cầu xuất hóa đơn của bạn đã được gửi thành công.\r\nNhân viên sẽ xử lý trong vòng 7 ngày làm việc, vui lòng kiểm tra email.',
  Confirm: 'Xác nhận',
  Submit: 'Nộp',
  ApplicationSubmissionFailed: 'Nộp đơn thất bại',
  InvoiceApplicationFailed:
    'Nộp đơn xin hóa đơn thất bại. Vui lòng tải lại hoặc liên hệ bộ phận hỗ trợ khách hàng',
  InvoiceApplicationSubmitted:
    'Yêu cầu xuất hóa đơn của bạn đã được gửi, vui lòng không lặp lại.',
  PleaseEnterName: 'Vui lòng nhập tên',
  PleaseEnterAddress: 'Vui lòng nhập địa chỉ',
  PleaseEnterInvoiceTitle: 'Vui lòng nhập tiêu đề hóa đơn',
  PleaseEnterEmail: 'Vui lòng nhập email nhận',
  PleaseEnterRemarks: 'Vui lòng nhập ghi chú',
  NumberParsingError: 'Số không hợp lệ',
  PleaseEnterValidEmailFormat: 'Vui lòng nhập đúng định dạng email',
  IncompleteInformation: 'Thông tin chưa đầy đủ, vui lòng kiểm tra',
  ExpandAll: 'Mở toàn bộ'
};
